import Hero from "@/components/Hero";
import LinkButtons from "@/components/LinkButtons";
import CekStatusInline from "@/components/CekStatusInline";
import CaraBelanja from "@/components/CaraBelanja";
import RulesPreview from "@/components/RulesPreview";

export default function Home() {
    return (
        <div data-testid="page-home">
            <Hero />
            <LinkButtons />
            <CekStatusInline />
            <CaraBelanja />
            <RulesPreview />
        </div>
    );
}
